import type { StrategyEntity } from '../strategy.type';

/**
 * Calculates the completion percentage for a strategy entity
 *
 * @param {StrategyEntity} entity - The strategy entity to calculate the completion percentage for
 * @returns The completion percentage
 */
const calculatePercentProgress = (entity: StrategyEntity): number => {
  const anyEntity = entity as any;
  let percentProgress = typeof anyEntity.percent_progress === 'number' ? anyEntity.percent_progress : undefined;
  // For epics, calculate completion from subtasks
  if (percentProgress === undefined && anyEntity.subtasks_count !== undefined) {
    const subtasksCount = anyEntity.subtasks_count || 0;
    const completedCount = anyEntity.subtasks_completed_count || 0;
    percentProgress = subtasksCount > 0 ? Math.round((completedCount / subtasksCount) * 100) : 0;
  }

  return typeof percentProgress === 'number' ? percentProgress : 0;
};

export { calculatePercentProgress };
